export enum FormFieldOptions {
    DO_NOT_SHOW = "Do not show",
    SHOW_AND_MANDATORY = "Show and mandatory",
    SHOW_AND_NOT_MANDATORY = "Show and not mandatory",
}
